//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapGetters } from 'vuex';
import { isEmpty } from 'lodash';

export default {
  name: 'Overview',
  data() {
    return {
      dataList: null,
      newsList: [
        {
          type: 0,
          title: 'OpenNet Limited 開網有限公司',
          content:
            '本公司目前正在招募【審查設計人員(週週休不加班)】人才，透過人力銀行看到您的資料...',
        },
        {
          type: 1,
          title: 'OpenNet Limited 開網有限公司',
          content:
            '本公司目前正在招募【審查設計人員(週週休不加班)】人才，透過人力銀行看到您的資料...',
        },
      ],
      statusMenu: [
        { label: '最新', value: null },
        { label: '系統消息', value: 1 },
        { label: '面試通知', value: 0 },
      ],
      statusMenuActive: 0,
      status: null,
      totalNum: 0,
      currentPage: 1,
      pageSize: 10,
    };
  },
  computed: {
    ...mapGetters('user', ['userName']),
    isEmptyData() {
      return isEmpty(this.dataList);
    },
    isMessageOpen() {
      return process.env.isMessageOpen;
    },
  },
  methods: {
    onStatusMenuClick(index, value) {
      this.status = value;
      this.statusMenuActive = index;
    },
    getOwnerJobs() {
      const payload = {
        current: this.currentPage,
        size: this.pageSize,
        status: this.status,
      };

      this.$api('getOwnerJobs', payload).then(data => {
        this.dataList = data.records;
        this.totalNum = data.total;
      });
    },
  },
  mounted() {
    this.getOwnerJobs();
  },
};
